var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3547 17.4033C33.3547 16.1966 33.2464 15.0363 33.0453 13.9224H17.0176V20.5052H26.1763C25.7818 22.6324 24.5828 24.4347 22.7804 25.6414V29.9114H28.2803C31.4982 26.9487 33.3547 22.586 33.3547 17.4033Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0183 34.0361C21.6131 34.0361 25.4653 32.5123 28.281 29.9132L22.7811 25.6433C21.2573 26.6643 19.308 27.2677 17.0183 27.2677C12.5859 27.2677 8.83426 24.2741 7.49604 20.2517H1.81055V24.6609C4.61075 30.2226 10.3659 34.0361 17.0183 34.0361Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49557 20.2514C7.15522 19.2304 6.96183 18.1397 6.96183 17.018C6.96183 15.8964 7.15522 14.8057 7.49557 13.7846V9.37549H1.81008C0.657506 11.6729 0 14.272 0 17.018C0 19.7641 0.657506 22.3632 1.81008 24.6606L7.49557 20.2514Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0183 6.76845C19.5168 6.76845 21.7601 7.62707 23.5237 9.31338L28.4048 4.43237C25.4576 1.68631 21.6054 0 17.0183 0C10.3659 0 4.61075 3.81354 1.81055 9.37527L7.49604 13.7844C8.83426 9.76204 12.5859 6.76845 17.0183 6.76845Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.ace2a2f76f0c69d6d9b7c747d5a3f3bb.svg";
export { ForwardRef as ReactComponent };